import { render, staticRenderFns } from "./PictureUploader.vue?vue&type=template&id=3f0d809f"
import script from "./PictureUploader.vue?vue&type=script&lang=js"
export * from "./PictureUploader.vue?vue&type=script&lang=js"
import style0 from "./PictureUploader.vue?vue&type=style&index=0&id=3f0d809f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports